import Vue from 'vue'
import { errorMessage } from '@/utils/format'

const state = Vue.observable({
    show: false,
    text: '',
    color: 'success',
    timeout: 4000
})

function show(text, color, timeout) {
    state.show = false
    Vue.nextTick(() => {
        state.text = text
        state.color = color
        state.timeout = timeout
        state.show = true
    })
}

export const notify = {
    state,
    success: text => show(text, 'success', 4000),
    info: text => show(text, 'info', 4000),
    error: (error, fallback) => show(errorMessage(error, fallback), 'error', 8000)
}

export default {
    install(VueInstance) {
        VueInstance.prototype.$notify = notify
    }
}
